import * as z from 'zod';

import {
  cleanNumericString,
  nullableNumericQuerySchema,
  nullableNumericToNumericStringConverter,
  nullableStringToNullableFloatConverter,
  numericStringFormSchema,
} from './numeric-value';

function formSchemaWithValidation(min = -1, max = Number.MAX_SAFE_INTEGER) {
  return numericStringFormSchema()
    .refine((val) => (nullableStringToNullableFloatConverter(val) ?? 0) > min, {
      message: 'Please enter a value greater than ' + min,
    })
    .refine((val) => (nullableStringToNullableFloatConverter(val) ?? 0) < max, {
      message: 'Please enter a value lesser than ' + max,
    });
}

function priceSchema(min = -1, max = Number.MAX_SAFE_INTEGER) {
  return z
    .number()
    .refine((val) => val > min, { message: 'Please enter a value greater than ' + min })
    .refine((val) => val < max, {
      message: 'Please enter a value lesser than ' + max,
    });
}

export const currencyInput = {
  defaultValue: () => '',
  querySchema: nullableNumericQuerySchema,
  formSchema: numericStringFormSchema,
  mutationSchema: nullableNumericQuerySchema,
  formSchemaWithValidation,
  cleanNumericString,
  queryToFormConverter: nullableNumericToNumericStringConverter,
  formToUpdateConverter: nullableStringToNullableFloatConverter,
  priceSchema,
};
